export const MIN_DAYS_FROM_NOW = 0;
export const SCREEN_TITLE = "Bảo hiểm cửa hàng/nhà";

/** Mockup hiển thị trên card ngoài màn hình chính theo bản draft */
export const MOCK_TNDS_CARD_TITLE = "Bảo hiểm cháy nổ/hàng hóa";
export const MOCK_TNDS_PREVIEW_BULLETS = [
  "Thủ tục mua rất đơn giản chỉ cần họ tên, số điện thoại người mua và địa chỉ nơi được bảo hiểm",
  "Không yêu cầu đánh giá giá trị thực tế của tài sản cửa hàng & hàng hóa",
  "Giấy chứng nhận bảo hiểm trực tuyến",
];

/** Mockup chi tiết quyền lợi trong modal */
export const MOCK_TNDS_BULLETS = [
  "Thủ tục mua rất đơn giản chỉ cần họ tên, số điện thoại người mua và địa chỉ nơi được bảo hiểm",
  "Không yêu cầu đánh giá giá trị thực tế của tài sản cửa hàng & hàng hóa",
  "Giấy chứng nhận bảo hiểm trực tuyến – 100% online",
  "Sửa bao nhiêu, đền bấy nhiêu – không trừ khấu hao",
  "Sự cố xảy ra? Báo PVI trong 48h là được tiếp nhận xử lý",
];

/** Mockup tab 2 — gắn với quy tắc cháy nổ / hàng hóa */
export const MOCK_FIRE_RULES_TITLE = "Quy tắc bảo hiểm cháy nổ & hàng hóa";
export const MOCK_FIRE_RULES_BULLETS = [
  "Phạm vi bảo hiểm: Cháy (do nổ hoặc nguyên nhân khác), sét đánh trực tiếp, nổ hơi đốt – không bao gồm động đất, lửa ngầm, núi lửa phun",
  "Loại trừ: Chiến tranh, khủng bố, bạo động; thiệt hại phi vật chất (chi phí thuê nhà, tổn hại tinh thần); tiền mặt, vàng bạc, đá quý, phương tiện cơ giới trong nhà",
  "Bồi thường nhà/cửa hàng: Theo chi phí sửa chữa thực tế, không trừ khấu hao; tối đa 50% số tiền bảo hiểm nếu nhận bằng tiền mặt",
  "Bồi thường hàng hóa: Theo giá trị tồn kho thực tế bị tổn thất; tối đa 50% nếu không cung cấp được hóa đơn/chứng từ chứng minh",
  "Thủ tục bồi thường: Báo PVI trong 48h kể từ khi xảy ra tổn thất; cần xác nhận của chính quyền địa phương; chuẩn bị hình ảnh hiện trường, hóa đơn và biên bản kiểm kê hàng hóa",
];
export const FIRE_RULES_PDF_LINK = "https://adminweb.pvi.com.vn/wp-content/uploads/2025/05/Quy-tac-bao-hiem-12.pdf";

export const BENEFIT_SHEET_TABS = {
  detail: "detail",
  rules: "rules",
};

export const benefitSheetModalStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(20, 43, 67, 0.5)",
    zIndex: 200,
  },
  content: {
    top: "auto",
    left: "auto",
    right: "auto",
    bottom: 0,
    margin: "0 auto",
    padding: 0,
    width: "100%",
    maxWidth: "100%",
    maxHeight: "85vh",
    border: "none",
    borderRadius: "16px 16px 0 0",
    overflow: "hidden",
    background: "#fff",
    display: "flex",
    flexDirection: "column",
    minHeight: 0,
    boxSizing: "border-box",
  },
};
